import { getBreakpoint } from '@/css/breakpoints';
import { useWindowSize } from './useWindowSize';
export function useBreakpoint() {
    const { width } = useWindowSize();
    return getBreakpoint(width);
}
